import { DG_axios } from "../../../../../custom/axios";
import { DG_axiosNormal } from "../../../../../custom/axios/normal";

const doConfigObjectUrl = "/dogoo/workflow-rest/v2.0/do-config-objects"
const urlEngine = `/dogoo/workflow-engine-rest/v2.0/do-process`;

const postProcessGatewayUrl = "/dogoo/process-gateway-rest/v2.0/process"
const processUrl = "/dogoo/workflow-process-rest/v2.0/request-process"

const transitionUrl = "/dogoo/process-gateway-rest/v2.0/process/account/assignee"

export async function getDoConfigObjects() {

    const response = await DG_axios.get(doConfigObjectUrl)

    return response.data || []
}

export async function getProcessAssignObject({ moduleCode, appCode, classPk }) {

    const response = await DG_axiosNormal.get(
        postProcessGatewayUrl + "/assignee",
        { noMessage: true, params: { moduleCode, appCode, classPk } })
    return response.data || []
}

export async function recallProcessApi({ classPk, moduleCode, appCode, message }) {

    const response = await DG_axiosNormal.post(
        processUrl,
        { classPk, moduleCode, appCode, message },
        { noMessage: true }
    )

    return response?.data || {}
}

export async function rollbackProcessApi({ classPk, moduleCode, appCode, type, approval, message }) {
    const response = await DG_axiosNormal.put(
        processUrl + `/${classPk}`,
        { classPk, moduleCode, appCode, type, approval, message },
        { noMessage: true }
    )

    return response?.data || {}
}

export async function postWorkflowProcessEngine(value) {
    const response = await DG_axiosNormal.post(urlEngine, value)
    return response?.data || {}
}

export async function deleteProcessGateWay({ moduleCode, appCode, classPk }) {
    const url = `/dogoo/process-gateway-rest/v2.0/process/profile`

    const response = await DG_axiosNormal.delete(
        url
        , {
            params: {
                moduleCode,
                appCode,
                classPk
            }
        })
    return response?.data || []
}

export async function assignToMe({ moduleCode, appCode, classPk }) {
    const params = {
        moduleCode,
        appCode,
        classPk
    }

    const response = await DG_axios.get(transitionUrl, { params });

    return response?.data || []
}